import { SearchCondition } from 'commons/constants/KeyFlowConstants';
import { AscType, SortType } from 'commons/constants/type';
import KeyFlowParamVO from 'commons/vo/param/KeyFlowParamVO';

export type AssetParamVOProps = {
  id?: number;
  isDeleted?: boolean;
  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType;
};

class AssetParamVO extends KeyFlowParamVO {
  id?: number;
  isDeleted?: boolean;
  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType;

  constructor(data: AssetParamVOProps) {
    super();
    this.id = data.id;
    this.isDeleted = data.isDeleted || false;

    this.retr = data.retr || 10;
    this.page = data.page || 0;
    this.sort = data.sort || SearchCondition.Sort.DATE_OF_GAME;
    this.asc = data.asc || SearchCondition.Asc.DESC;
  }
}

export default AssetParamVO;
